var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"card-dots"},_vm._l((_vm.dots),function(item){return _c('li',{key:_vm.itemId + '_' + item,class:{ 'is-set': item > (_vm.dots.length - (_vm.dotValue+1)) }},[_c('span')])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }